import { Link } from 'react-router';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { toast } from 'sonner';

type ErrorPageProps = {
  title: string;
  description: string;
  isNotFound?: boolean;
};

export const ErrorPage = ({ title, description, isNotFound = false }: ErrorPageProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const supportFormUrl =
    'https://docs.google.com/forms/d/e/1FAIpQLSfNegE8ahLYOhxKRQ4_GzpPq3E2Xg69dEPl2cObZ4pAqezbIQ/viewform?usp=sharing&ouid=118188424649909568675';

  return (
    <div className='min-h-screen flex items-center justify-center p-4'>
      <Card className='w-full max-w-md'>
        <CardHeader>
          <CardTitle className='text-2xl font-bold'>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent>
          {isNotFound ? (
            <p className='text-muted-foreground'>
              お探しのページが見つかりませんでした。URLが正しいかご確認ください。
            </p>
          ) : (
            <p className='text-muted-foreground'>
              申し訳ありませんが、予期せぬエラーが発生しました。
              しばらく時間をおいて再度お試しください。
            </p>
          )}
        </CardContent>
        <CardFooter className='flex flex-col gap-4'>
          <Button asChild className='w-full'>
            <Link to='/'>トップページに戻る</Link>
          </Button>
          <div className='text-center text-sm text-muted-foreground'>
            <p>問題が解決しない場合は、以下のフォームからお問い合わせください：</p>
            <div className='mt-2'>
              <Button asChild variant='link' className='text-primary'>
                <a href={supportFormUrl} target='_blank' rel='noopener noreferrer'>
                  お問い合わせフォームを開く
                </a>
              </Button>
            </div>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};
